import { FiSearch, FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { toggleSearchBar } from "../../store/reducers/globalReducer";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { productUrl } from "../../utils/productUrl";
import { useFilterProductsQuery } from "../../store/services/homeProducts";
import { imageUrl } from "../../utils/imageUrl";
import { toman } from "../../utils/persian";

const Search = () => {
  const { searchBar } = useSelector((state) => state.globalReducer);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedKeyword(keyword.trim());
    }, 350);

    return () => clearTimeout(timer);
  }, [keyword]);

  const { data, isFetching } = useFilterProductsQuery(
    {
      q: debouncedKeyword,
      per_page: 6,
      page: 1
    },
    {
      skip: debouncedKeyword.length < 2
    }
  );

  useEffect(() => {
    document.body.style.overflow = searchBar ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [searchBar]);

  const closeSearch = () => {
    dispatch(toggleSearchBar());
    setKeyword("");
    setDebouncedKeyword("");
  };

  const submitSearch = (e) => {
    e.preventDefault();

    if (keyword.trim().length > 0) {
      navigate(`/search-products/${keyword.trim()}/1`);
      closeSearch();
    }
  };

  return (
    <div className={`search-overlay ${searchBar ? "active" : ""}`} role={searchBar ? "dialog" : undefined} aria-modal={searchBar ? "true" : undefined} aria-label="جستجوی محصولات">
      <div className="search-panel">
        <button type="button" onClick={closeSearch} className="search-close-btn" aria-label="بستن جستجو">
          <FiX size={26} />
        </button>

        <div className="search-content">
          <span className="search-eyebrow">جستجوی سریع</span>

          <h2>دنبال چه مدلی هستی؟</h2>

          <form onSubmit={submitSearch} className="search-form-modern">
            <FiSearch size={22} />

            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="مثلاً اسپورت، صندل زنانه، مجلسی..."
              autoFocus={searchBar}
              aria-label="عبارت جستجوی محصول"
            />

            <button type="submit">جستجو</button>
          </form>

          {debouncedKeyword.length >= 2 && (
            <div className="search-live-box">
              <div className="search-live-head">
                <strong>نتایج مرتبط</strong>
                {isFetching && <span>در حال جستجو...</span>}
              </div>

              {data?.products?.length > 0 ? (
                <div className="search-live-list">
                  {data.products.map((product) => (
                    <Link
                      to={productUrl(product)}
                      className="search-live-item"
                      key={product._id || product.id}
                      onClick={closeSearch}
                    >
                      <img src={imageUrl(product.image1 || product.main_image)} alt={product.title || product.name} loading="lazy" />

                      <div>
                        <strong>{product.title || product.name}</strong>
                        <span>{product.category || "محصول جوتی"}</span>
                      </div>

                      <b>{toman(product.sale_price || product.price)}</b>
                    </Link>
                  ))}
                </div>
              ) : !isFetching ? (
                <p className="search-empty">محصولی پیدا نشد.</p>
              ) : null}

              {data?.products?.length > 0 && (
                <button type="button" className="search-see-all" onClick={submitSearch}>
                  مشاهده همه نتایج
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Search;
